if (!customElements.get('swiper-slider-component')) {
  customElements.define(
    'swiper-slider-component',
    class CustomSliderComponent extends HTMLElement {
      constructor() {
        super();
        this.swiperWrapper = this.querySelector('.swiper-wrapper');
        this.swiperInstance = null;
        this._handleResize = this.initBasedOnDevice.bind(this);
      }

      connectedCallback() {
        this.initBasedOnDevice();
        this.cloneTabButton();
        window.addEventListener('resize', this._handleResize);
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this._handleResize);
        if (this.swiperInstance) {
          this.swiperInstance.destroy(true, true);
          this.swiperInstance = null;
        }
      }

      initBasedOnDevice() {
        const pcSlider = this.getAttribute('pc-slider') === 'true';
        const mobileSlider = this.getAttribute('mobile-slider') === 'true';
        const screenWidth = window.innerWidth;
        const shouldInit =
          (screenWidth < 769 && mobileSlider) ||
          (screenWidth >= 769 && pcSlider);

        if (shouldInit && !this.swiperInstance) {
          this.initializeSwiper();
        } else if (!shouldInit && this.swiperInstance) {
          this.swiperInstance.destroy(true, true);
          this.swiperInstance = null;
          const bannerNav = this.querySelector('.banner-navigation');
          if (bannerNav) bannerNav.innerHTML = '';
        }
      }

      cloneTabButton() {
        const tabButtonNames = this.querySelectorAll('.tab-name');
        const tabContents = this.querySelectorAll('.swiper-tab-content');

        tabContents.forEach(tabContent => {
          // clear previous clones to avoid duplicates
          tabContent.querySelectorAll('.tab-name').forEach(el => el.remove());

          tabButtonNames.forEach(tabButton => {
            const cloneTabName = tabButton.cloneNode(true);
            cloneTabName.style.display = 'block';
            tabContent.appendChild(cloneTabName);

            // ✅ Add click listener to slide Swiper when tab is clicked
            cloneTabName.addEventListener('click', () => {
              if (!this.swiperInstance) return;
              const index = Array.from(tabButtonNames).indexOf(tabButton);
              if (this.swiperInstance.loop) {
                this.swiperInstance.slideToLoop(index);
              } else {
                this.swiperInstance.slideTo(index);
              }
              this.updateActiveTabButton();
            });
          });
        });
      }

      updateActiveTabButton() {
        if (!this.swiperInstance) return;

        const activeIndex = this.swiperInstance.realIndex; // current active slide
        const clonedTabs = this.querySelectorAll('.swiper-tab-content .tab-name');

        clonedTabs.forEach((tab, index) => {
          if (index === activeIndex) {
            tab.classList.add('active');  // highlight active tab
          } else {
            tab.classList.remove('active');
          }
        });
      }

      initializeSwiper() {
        if (window.Swiper) {
          this.initSwiperInstance();
          return;
        }

        if (!document.querySelector('script[data-swiper-loaded]')) {
          const swiperScript = document.createElement('script');
          swiperScript.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
          swiperScript.dataset.swiperLoaded = 'true';
          swiperScript.onload = () => this.initSwiperInstance();
          document.head.appendChild(swiperScript);
        } else {
          const checkSwiper = setInterval(() => {
            if (window.Swiper) {
              this.initSwiperInstance();
              clearInterval(checkSwiper);
            }
          }, 100);
        }
      }

      initSwiperInstance() {
        const pcItems =
          parseFloat(this.swiperWrapper.getAttribute('data-carousel-item-pc')) || 3;
        const mobileItems =
          parseFloat(this.swiperWrapper.getAttribute('data-carousel-item-mobile')) || 1.5;
        const tabletItems =
          parseFloat(this.swiperWrapper.getAttribute('data-carousel-item-tablet')) || 1.5;
        const itemGap =
          parseFloat(this.swiperWrapper.getAttribute('data-carousel-item-gap')) || 32;
        const centerSlide = this.getAttribute('center-slide') === 'true';
        const loopSlide = this.getAttribute('loop') === 'true';

        const isMobile = window.innerWidth < 1024;
        const pcSlider = this.getAttribute('pc-slider') === 'true';
        const mobileSlider = this.getAttribute('mobile-slider') === 'true';
        const shouldShowControls =
          (isMobile && mobileSlider) || (!isMobile && pcSlider);

        this.swiperInstance = new Swiper(this.querySelector('.swiper'), {
          loop: loopSlide,
          spaceBetween: itemGap,
          centeredSlides: isMobile && centerSlide,
          pagination: shouldShowControls
            ? { el: this.querySelector('.swiper-pagination') }
            : false,
          navigation: shouldShowControls
            ? {
                nextEl: this.querySelector('.swiper-button-next'),
                prevEl: this.querySelector('.swiper-button-prev'),
              }
            : {},
          scrollbar: shouldShowControls
            ? { el: this.querySelector('.swiper-scrollbar'), hide: true }
            : false,
          breakpoints: {
            300: { slidesPerView: mobileItems, centeredSlides: centerSlide, spaceBetween: 16 },
            580: { slidesPerView: tabletItems, centeredSlides: centerSlide, spaceBetween: 16 },
            780: { slidesPerView: tabletItems, centeredSlides: centerSlide },
            1024: { slidesPerView: pcItems, centeredSlides: false },
          },
          on: {
            slideChange: () => {
              // ✅ update cloned tabs when slide changes
              this.updateActiveTabButton();
            },
          },
        });

        // initialize first active state
        this.updateActiveTabButton();

        if (!isMobile && !pcSlider) {
          this.querySelectorAll(
            '.swiper-button-prev, .swiper-button-next, .swiper-pagination'
          ).forEach((el) => (el.style.display = 'none'));
        }
      }
    }
  );
}
